import { render, staticRenderFns } from "./online.vue?vue&type=template&id=480c9872&scoped=true&"
import script from "./online.vue?vue&type=script&lang=js&"
export * from "./online.vue?vue&type=script&lang=js&"
import style0 from "./online.vue?vue&type=style&index=0&id=480c9872&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480c9872",
  null
  
)

export default component.exports